module.exports = __webpack_public_path__ + "img/Turtle.39c1da3e.png";